/*
 * jdgm-auto-translate.js
 * Free, best-effort auto-translation of Judge.me review CONTENT to the
 * active storefront language (de -> en / ar), using the free MyMemory API.
 *
 * Why this exists: the store is on Judge.me's free plan, which has no built-in
 * review-content translation. This script translates the visible review text
 * client-side so English/Arabic visitors can read German reviews.
 *
 * Notes / trade-offs:
 *  - Machine translation quality (like Google Translate).
 *  - Results are cached in localStorage so each text is translated only once.
 *  - Requests are queued (max 3 at a time) to stay gentle on the free API.
 *  - If the API fails, the original German text is left untouched.
 */
(function () {
  var SRC = 'de';                 // source language of the reviews
  var SUPPORTED = ['en', 'ar'];   // only translate on these storefront locales

  function getTargetLang() {
    var l =
      (window.Shopify && Shopify.locale) ||
      document.documentElement.getAttribute('lang') ||
      'de';
    return l.toLowerCase().slice(0, 2);
  }

  var target = getTargetLang();
  if (target === SRC || SUPPORTED.indexOf(target) === -1) return;

  var CACHE_PREFIX = 'jdgmtr_' + target + '_';

  function hash(s) {
    var h = 0, i, c;
    for (i = 0; i < s.length; i++) {
      c = s.charCodeAt(i);
      h = ((h << 5) - h) + c;
      h |= 0;
    }
    return h;
  }

  function getCached(text) {
    try { return localStorage.getItem(CACHE_PREFIX + hash(text)); } catch (e) { return null; }
  }
  function setCached(text, value) {
    try { localStorage.setItem(CACHE_PREFIX + hash(text), value); } catch (e) {}
  }

  /* ---- simple request queue (max 3 concurrent) ---- */
  var queue = [];
  var active = 0;
  var MAX = 3;

  function pump() {
    while (active < MAX && queue.length) {
      var job = queue.shift();
      active++;
      job();
    }
  }

  function translate(text, cb) {
    text = (text || '').trim();
    if (!text) { cb(null); return; }

    var cached = getCached(text);
    if (cached !== null) { cb(cached); return; }

    queue.push(function () {
      var url =
        'https://api.mymemory.translated.net/get?q=' +
        encodeURIComponent(text) +
        '&langpair=' + SRC + '|' + target;

      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var t = d && d.responseData && d.responseData.translatedText;
          // MyMemory returns warnings/quota messages in ALL CAPS on failure
          if (t && d.responseStatus === 200) {
            setCached(text, t);
            cb(t);
          } else {
            cb(null);
          }
        })
        .catch(function () { cb(null); })
        .then(function () { active--; pump(); });
    });
    pump();
  }

  /* ---- elements that hold review text ---- */
  var SELECTORS = [
    '.jdgm-rev__title',                  // main review widget – title
    '.jdgm-rev__body',                   // main review widget – body
    '.jdgm-carousel-item__review-title', // classic carousel – title
    '.jdgm-carousel-item__review-body',  // classic carousel – body
    '.jdgm-media-card .jdgm-text',       // cards / media carousel – text
    '.jdgm-media-card .jdgm-text p'
  ];

  function processEl(el) {
    if (!el || el.getAttribute('data-jdgm-tr') === target) return;
    var original = el.textContent;
    if (!original || !original.trim()) return;
    el.setAttribute('data-jdgm-tr', target); // mark first to avoid re-processing
    translate(original, function (t) {
      if (t) el.textContent = t;
    });
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    for (var i = 0; i < SELECTORS.length; i++) {
      var nodes = root.querySelectorAll(SELECTORS[i]);
      for (var j = 0; j < nodes.length; j++) processEl(nodes[j]);
    }
  }

  function init() {
    scan(document);
    // Judge.me widgets load asynchronously, so watch for new nodes.
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) scan(added[j]);
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
